<template>
  <div class="card mb-3">
    <div class="card-body">
      <Loading v-if="showLoading" />
      <div class="row">
        <div class="col-md-3">
          <label> از تاریخ</label>
          <Datepicker
            simple
            auto-submit
            id="from-date"
            locale="fa"
            input-format="YYYY-MM-DD"
            :max="today"
            v-model="fromDate"
            :locale-config="{
              fa: {
                displayFormat: 'jYYYY/jMM/jDD',
                lang: { label: 'شمسی' },
              },
            }"
          />
        </div>
        <div class="col-md-3">
          <label> تا تاریخ</label>
          <Datepicker
            simple
            auto-submit
            id="to-date"
            locale="fa"
            input-format="YYYY-MM-DD"
            :min="fromDate"
            :max="today"
            v-model="toDate"
            :locale-config="{
              fa: {
                displayFormat: 'jYYYY/jMM/jDD',
                lang: { label: 'شمسی' },
              },
            }"
          />
        </div>
        <div class="form-group col-md-3">
          <label>عنوان </label>
          <input class="form-control input" v-model="title" />
        </div>
      </div>
      <div class="row" style="display: flex; justify-content: end">
        <!-- <div v-if="isSearched" class="col-md-3">
          <button class="btn btn-info btn-block" @click="getFullExelPath">
            دریافت فایل اکسل کل
          </button>
        </div>
        <div v-if="isSearched" class="col-md-3">
          <button class="btn btn-warning btn-block" @click="getExelPath">
            دریافت فایل اکسل
          </button>
        </div> -->
        <div class="col-md-3">
          <button class="btn btn-primary btn-block" @click="submit">
            <!-- :disabled="!fromDate || !toDate || !title" -->
            <i class="si si-magnifier"></i>
            جستجو
          </button>
        </div>
      </div>
      <div class="alert alert-info mt-4 mb-0" v-if="!rows.length && isSearched">
        <p class="mb-0">اطلاعاتی یافت نشد</p>
      </div>
      <hr v-if="rows.length" />
      <!-- <div class="row">
        <div class="col-md-1">
          <div class="form-group">
            <label>تعداد</label>
            <select v-model="perPage" class="form-control">
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="200">200</option>
            </select>
          </div>
        </div>
        <div class="col-md-8"></div>
        <div class="col-md-3 text-left" style="margin-top:26px">
          تعداد کل ردیف ها : {{ count }} ردیف
        </div>
      </div> -->
      <table class="table table-hover table-bordered mb-0" v-if="rows.length">
        <thead>
          <tr>
            <th>ردیف</th>
            <th>نام درخواست</th>

            <th>تاریخ درخواست</th>
            <th>تعداد</th>

            <th>جمع مبلغ شارژ (ریال)</th>
            <th>جمع برداشت از سپرده (ریال)</th>
            <th>جمع شارژ کیف پول (ریال)</th>
            <th>متن پیامک</th>
            <!-- <th>وضعیت شارژ</th> -->
            <th>وضعیت درخواست</th>
            <th>عملیات</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in rows" :key="index">
            <td>{{ index + 1 }}</td>

            <td>{{ row.title }}</td>
            <td>{{ row.requestDateShamsi }}</td>
            <td>{{ row.detailsCount }}</td>

            <td>
              {{
                row.totalChargeAmountSum
                  ? new Intl.NumberFormat("en-IR", {
                      maximumSignificantDigits: 20,
                    }).format(row.totalChargeAmountSum)
                  : "0"
              }}
            </td>
            <td>
              {{
                row.sumDepositWithdrawSuccessAmount
                  ? new Intl.NumberFormat("en-IR", {
                      maximumSignificantDigits: 20,
                    }).format(row.sumDepositWithdrawSuccessAmount)
                  : "0"
              }}
            </td>
            <td>
              {{
                row.sumWalletChargeSuccessAmount
                  ? new Intl.NumberFormat("en-IR", {
                      maximumSignificantDigits: 20,
                    }).format(row.sumWalletChargeSuccessAmount)
                  : "0"
              }}
            </td>
            <td>{{ row.smsText }}</td>
            <!-- <td>{{ row.acceptForChargeText }}</td> -->
            <td>{{ row.chargeAggregateStatusText }}</td>
            <td>
              <router-link
                :to="{
                  name: 'jahesh.chargeReport',
                  params: { id: row.jaheshChargeRequestId },
                }"
                class="d-inline-block ml-2"
                title="مشاهده جزییات"
              >
                <button class="btn btn-primary">جزییات</button>
                <!-- <i class="ti-eye operationsIcon">
                  </i -->
              </router-link>
              <button
                v-if="
                  row.acceptForCharge === 0 && row.chargeAggregateStatus !== 3
                "
                title="تایید شارژ"
                class="btn btn-success"
                @click="() => acceptCharge(row.jaheshChargeRequestId)"
              >
                تایید
                <!-- <i class="fa fa-play operationsIcon"></i> -->
              </button>
              <button
                v-if="row.acceptForCharge === 0"
                title="حذف"
                class="btn btn-danger mx-1"
                @click="
                  () => deleteCharge(row.jaheshChargeRequestId, row.title)
                "
              >
                حذف
              </button>
              <button
                v-if="
                  row.acceptForCharge !== 0 && row.chargeAggregateStatus !== 3
                "
                title="توقف شارژ"
                class="btn btn-danger"
                @click="() => stopCharge(row.jaheshChargeRequestId)"
              >
                توقف شارژ
                <!-- <i class="fa fa-stop operationsIcon danger"></i> -->
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <Pagination
        :pages="pages"
        :currentPage="currentPage"
        :prevPageMethod="(e) => currentPage--"
        :nextPageMethod="(e) => currentPage++"
        :changePageMethod="(e, page) => (currentPage = page)"
      />
      <div class="row mt-3" v-if="pages.length > 1" style="overflow-x: hidden;">
        <div class="col-12" style="overflow-x: auto;">
          <ul class="pagination pagination-circled">
            <li class="page-item" v-if="currentPage > 1">
              <a class="page-link" href="#" v-on:click="currentPage--"
                ><i class="icon ion-ios-arrow-forward"></i
              ></a>
            </li>
            <li
              :class="currentPage == page ? 'page-item active' : 'page-item'"
              v-for="(page, index) in pages"
              :key="index"
            >
              <div style="display: flex; flex-direction: row;">
                <span class="page-link ml-1" v-if="page > pages[index - 1] + 1">
                  ...
                </span>
                <a class="page-link" href="#" v-on:click="currentPage = page">{{
                  page
                }}</a>
              </div>
            </li>
            <li class="page-item" v-if="pages.length != currentPage">
              <a class="page-link" href="#" v-on:click="currentPage++"
                ><i class="icon ion-ios-arrow-back"></i
              ></a>
            </li>
          </ul>
        </div>
      </div>
      <p v-if="rows.length" class="mt-4 mb-0">تعداد کل : {{ count }}</p>
    </div>
  </div>
</template>
<script>
import Pagination from "../Partials/Pagination";
import moment from "moment-jalaali";
export default {
  name: "ChargeList",
  components: { Pagination },
  data() {
    return {
      showLoading: false,
      isSearched: false,
      rows: [],
      fromDate: "",
      toDateMax: moment().format("jYYYY-jMM-jDD"),
      fromDateMax: moment().format("jYYYY-jMM-jDD"),
      today: new Date().toString(),
      fromDateMin: "",
      toDate: "",
      currentPage: 1,
      pages: [1],
      perPage: 10,
      count: 0,
      type: 0,
      title: "",
    };
  },
  watch: {
    currentPage(value) {
      this.currentPage = value;
      this.getData();
    },
    perPage(value) {
      if (this.count == 0) return;
      if (value) this.getData();
    },

    toDate(value) {
      this.fromDateMax = this.toDate;
    },
  },
  methods: {
    handlePaginateArray(pagesCount) {
      let pagesArray = [1];
      if (pagesCount > 1) {
        if (this.currentPage > 2) pagesArray.push(this.currentPage - 1);
        if (this.currentPage > 1) pagesArray.push(this.currentPage);
        if (this.currentPage < pagesCount)
          pagesArray.push(this.currentPage + 1);
        const middle = Math.ceil(pagesCount / 2);
        if (middle > this.currentPage + 1 && middle < pagesCount - 2) {
          pagesArray.push(middle);
        }
        if (this.currentPage < pagesCount) pagesArray.push(pagesCount);
      }
      this.pages = pagesArray;
    },
    getExelPath() {
      this.showLoading = true;
      const postedData = {
        fromDate: this.fromDate.replace(/\//g, ""),
        toDate: this.toDate.replace(/\//g, ""),
        page: this.currentPage,
        perPage: this.perPage,
        organ: parseInt(this.organ),
        type: parseInt(this.type),
        cardNumber: this.pan.replace(/-/g, ""),
      };
      this.$api
        .post("cards/GetCardTransactionExcelReport", postedData)
        .then(({ data }) => {
          if (data.status) {
            let a = window.document.createElement("a");
            a.setAttribute(
              "href",
              "https://cardapi.sabinarya.com/api/v1/Lookup/download/" +
                data.result.fileName,
            );
            let fileName = data.result.filename;
            a.setAttribute("download", fileName);
            window.document.body.appendChild(a);
            a.click();
            window.document.body.removeChild(a);
            this.rows = result;
            this.count = data.result.count;
            let calcPages = Math.ceil(this.count / this.perPage);
            calcPages = calcPages > 1 ? calcPages : 1;
            let pagesArray = [];
            for (let i = 1; i <= calcPages; i++) pagesArray.push(i);
            this.pages = pagesArray;
          }
        })
        .finally(() => {
          this.isSearched = true;
          this.showLoading = false;
        });
    },
    getFullExelPath() {
      this.showLoading = true;
      const postedData = {
        fromDate: this.fromDate.replace(/\//g, ""),
        toDate: this.toDate.replace(/\//g, ""),
        page: 0,
        perPage: this.count,
        organ: parseInt(this.organ),
        type: parseInt(this.type),
        cardNumber: this.pan.replace(/-/g, ""),
      };
      this.$api
        .post("cards/GetCardTransactionExcelReport", postedData)
        .then(({ data }) => {
          if (data.status) {
            let a = window.document.createElement("a");
            a.setAttribute(
              "href",
              "https://cardapi.sabinarya.com/api/v1/Lookup/download/" +
                data.result.fileName,
            );
            let fileName = data.result.filename;
            a.setAttribute("download", fileName);
            window.document.body.appendChild(a);
            a.click();
            window.document.body.removeChild(a);
            this.rows = result;
            this.count = data.result.count;
            let calcPages = Math.ceil(this.count / this.perPage);
            calcPages = calcPages > 1 ? calcPages : 1;
            let pagesArray = [];
            for (let i = 1; i <= calcPages; i++) pagesArray.push(i);
            this.pages = pagesArray;
          }
        })
        .finally(() => {
          this.isSearched = true;
          this.showLoading = false;
        });
    },

    getData() {
      this.showLoading = true;
      let url = `Jahesh/ChargeRequests?page=${this.currentPage}&pageSize=${this.perPage}`;
      if (this.title) url += `&title=${this.title}`;
      if (this.fromDate) url += `&fromDate=${this.fromDate}`;
      if (this.toDate) url += `&toDate=${this.toDate}`;
      this.$api
        .get(url)
        .then(({ data }) => {
          if (data.status) {
            this.rows = data.result.list;
            this.count = data.result.totalCount;
            this.isSearched = true;
            this.showLoading = false;
            let calcPages = Math.ceil(data.result.totalCount / this.perPage);
            this.handlePaginateArray(calcPages);
          }
        })
        .finally(() => {
          this.isSearched = true;
          this.showLoading = false;
        });
    },
    submit() {
      this.getData();
    },
    acceptCharge(id) {
      this.$api
        .post(`Jahesh/ChargeRequests/${id}/ConfirmCharge`)
        .then(({ status }) => {
          if (status) {
            this.$swal({
              icon: "success",
              title: "تایید !",
              text: "درخواست شارژ تایید شد",
            });
            this.getData();
          }
        });
    },
    deleteCharge(id, title) {
      this.$dialog
        .confirm(`آیا از حذف شارژ ${title} اطمینان دارید ؟ `)
        .then((dialog) => {
          this.$api
            .get(`Jahesh/DeletedChargeRequest/${id}`)
            .then(({ data }) => {
              if (data.status) {
                this.$swal({
                  icon: "success",
                  title: "حذف شد !",
                  text: `درخواست شارژ ${title} حذف شد`,
                });
                this.getData();
              }
            });
        });
    },
    stopCharge(id) {
      this.$api
        .post(`Jahesh/ChargeRequests/${id}/PreventCharge`)
        .then(({ status }) => {
          if (status) {
            this.$swal({
              icon: "success",
              title: "تایید !",
              text: "درخواست شارژ متوقف شد",
            });
            this.getData();
          }
        });
    },
  },
  created() {
    this.getData();
  },
};
</script>
